import { render, staticRenderFns } from "./VideoRequests-User.vue?vue&type=template&id=7cc1ae56&scoped=true"
import script from "./VideoRequests-User.js?vue&type=script&lang=js&external"
export * from "./VideoRequests-User.js?vue&type=script&lang=js&external"
import style0 from "./VideoRequests-User.vue?vue&type=style&index=0&id=7cc1ae56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc1ae56",
  null
  
)

export default component.exports